import React, { useState } from "react";
import "../components/FactoringInternacional.css";
import FormularioWeb from "../components/FormularioWeb";
import Footer from "../components/Footer";
import Requisitos from "../assets/img/requisitossmallWeb.png";
import RequisitosImg from "../assets/img/b7400x516.jpg";
import Beneficios from "../assets/img/PCP_Mesadetrabajo1.png";

const FactoringInternacional = () => {
  const [activeIndex, setActiveIndex] = useState(null);
 

  const toggleAccordion = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  
  return (
    <div className="containerInternacional">
      <div className="bannerInternacional">
        <h1 className="bannerInternacional-title">Factoring Internacional</h1>
      </div>
      <div className="containerBannerInternacional">
        <p className="textoBannerInternacional">
          Específico para empresas exportadoras. Sirve para adelantar el cobro
          de las facturas de tus clientes que se encuentran en distintos países
          del mundo.
        </p>
      </div>
      <div className="internacional-container">
        <h1 className="internacional-title">
          Factoring Internacional con nosotros en 6 simples pasos
        </h1>
        <div className="internacional-grid-container">
          <div className="internacional-grid-item">
            <span
              className="internacional-number"
              style={{ color: "rgb(37, 200, 207)" }}
            >
              1
            </span>
            <p className="internacional-description">
              Cierre del acuerdo de exportación y emisión de factura por parte
              del exportador.
            </p>
          </div>
          <div className="internacional-grid-item">
            <span
              className="internacional-number"
              style={{ color: "rgb(11, 155, 188)" }}
            >
              2
            </span>
            <p className="internacional-description">
              Formalización de documentación y presentación a Primus Capital por
              parte del exportador.
            </p>
          </div>
          <div className="internacional-grid-item">
            <span
              className="internacional-number"
              style={{ color: "rgb(22, 109, 170)" }}
            >
              3
            </span>
            <p className="internacional-description">
              Evaluación del corresponsal financiero.
            </p>
          </div>
          <div className="internacional-grid-item">
            <span
              className="internacional-number"
              style={{ color: "rgb(8, 116, 141)" }}
            >
              4
            </span>
            <p className="internacional-description">
              Aprobación de la solicitud e informe de condiciones.
            </p>
          </div>
          <div className="internacional-grid-item">
            <span
              className="internacional-number"
              style={{ color: "rgb(66, 88, 185)" }}
            >
              5
            </span>
            <p className="internacional-description">
              Cesión de las facturas al banco corresponsal.
            </p>
          </div>
          <div className="internacional-grid-item">
            <span
              className="internacional-number"
              style={{ color: "rgb(48, 66, 148)" }}
            >
              6
            </span>
            <p className="internacional-description">
              Administración de cobros al vencimiento dirigida al importador.
            </p>
          </div>
        </div>
      </div>

      {/* ---------------ACCORDION------------ */}
      <div className="accordionFactoring">
        <div className="accordion-itemFactoring">
          <div
            className="accordion-titleFactoring"
            onClick={() => toggleAccordion(1)}
          >
            <img
              src={Beneficios}
              className="beneficios"
              alt="Contratación del Factoring"
            />
            <span
              style={{
                fontSize: "30px",
                color: "rgb(22, 44, 118)",
                marginLeft: "1em",
              }}
            >
              Beneficios del factoring internacional
            </span>
            <i
              className={`fas ${
                activeIndex === 1 ? "fa-angle-up" : "fa-angle-down"
              }`}
              style={{ marginLeft: "auto" }}
            ></i>
          </div>
          {activeIndex === 1 && (
            <div className="accordion-contentFactoring">
              <div className="containerBeneficiosInternacional">
                <div className="columnBeneficioInternacional">
                  <strong>
                    Optimización de tiempo y recursos administrativos:
                  </strong>
                  <br />
                  Delegar tus facturas a un factor internacional no solo permite
                  liberar valiosos recursos, sino que también optimiza
                  significativamente el tiempo dedicado a estas tareas
                  administrativas.
                </div>
                <div className="columnBeneficioInternacional">
                  <strong>Internacionalización eficiente:</strong> <br />
                  El factoring internacional contribuye a una expansión
                  eficiente hacia mercados extranjeros, permitiendo a las
                  empresas trabajar de manera rápida y eficaz con clientes
                  internacionales.
                </div>
                <div className="columnBeneficioInternacional">
                  <strong>Mitigación de riesgos cambiarios:</strong>
                  <br /> La conversión de facturas pendientes de clientes
                  extranjeros en efectivo local a través del factor
                  internacional contribuye a reducir la exposición y mitigar el
                  riesgo de pérdida debido a fluctuaciones en los tipos de
                  cambio.
                </div>
                <div className="columnBeneficioInternacional">
                  <strong>Seguridad de relaciones con clientes:</strong>
                  <br /> Externalizar la gestión de cuentas por cobrar a un
                  factor internacional no solo optimiza los procesos, sino que
                  fortalece la confianza de poder trabajar con empresas
                  domiciliadas en el mismo país.
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="accordion-itemFactoring">
          <div
            className="accordion-titleFactoring"
            onClick={() => toggleAccordion(2)}
          >
            <img src={Requisitos} alt="Contratación del Factoring" />
            <span
              style={{
                fontSize: "30px",
                color: "rgb(22, 44, 118)",
                marginLeft: "1em",
              }}
            >
              Requisitos
            </span>
            <i
              className={`fas ${
                activeIndex === 2 ? "fa-angle-up" : "fa-angle-down"
              }`}
              style={{ marginLeft: "auto" }}
            ></i>
          </div>
          {activeIndex === 2 && (
            <div className="accordion-contentFactoring">
              <div className="requirementsFactoring">
                <div>
                  <img src={RequisitosImg} alt="Requisitos" />
                </div>

                <div>
                  <h3
                    style={{
                      textAlign: "center",
                      fontSize: "24px",
                      fontWeight: "bold",
                      marginBottom: "1em",
                    }}
                  >
                    Documentación
                  </h3>
                  <p>
                    Para la afiliación al factoring internacional en Primus
                    Capital es necesario presentar:
                  </p>
                  <ul>
                    <li>Declaración jurada (DJ 2023) + Estado financiero</li>
                  </ul>
                  <ul>
                    <li>Reporte Tributario (actualizado).</li>
                  </ul>
                  <ul>
                    <li>
                      Documentos de exportación: BL, Invoice, Packing list,
                      Orden de compra, certificado fitosanitario (de ser el
                      caso), Tracking Number.
                    </li>
                  </ul>
                  <ul>
                    <li>
                      Información del exportador, tener experiencia mínima de 2
                      años de exportación con su cliente en el extranjero.
                    </li>
                  </ul>
                  <ul>
                    <li>
                    Información del comprador en el extranjero (importador).
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <div className="formulario">
        <h2>¿Tienes facturas pendientes de cobro?</h2>
        <FormularioWeb />
      </div>
      <Footer />
    </div>
  );
};

export default FactoringInternacional;
